import React, { useState } from "react";
import DomainSeoHelmet from "../agentic/DomainSeoHelmet";
import DomainHiddenSeoContent from "../agentic/DomainHiddenSeoContent";
import DomainUseCaseCard, { DOMAIN_PAGE_STYLES } from "../agentic/domainUseCaseLayout";
import UseCaseIndexGrid from "../agentic/UseCaseIndexGrid";
import RpaProcessFlow from "./RpaProcessFlow";
import {
  LOGISTICS_DOMAIN_INTRO,
  LOGISTICS_GROUPS,
  LOGISTICS_USE_CASES_SEO,
  LOGISTICS_DOMAIN_FAQS,
  LOGISTICS_ITEM_LIST_JSONLD,
  LOGISTICS_BREADCRUMB_JSONLD,
  LOGISTICS_WEBPAGE_JSONLD,
  LOGISTICS_FAQ_JSONLD,
} from "../../data/rpa/logistics-domainUseCases";

function UseCaseCard({ useCase }) {
  return (
    <DomainUseCaseCard
      useCase={useCase}
      flow={<RpaProcessFlow useCase={useCase} />}
    />
  );
}

function GroupSection({ group }) {
  const cases = LOGISTICS_USE_CASES_SEO.filter((uc) => uc.groupId === group.id);
  if (!cases.length) return null;
  return (
    <section id={group.id} className="fin-section" aria-labelledby={`${group.id}-heading`}>
      <h2 id={`${group.id}-heading`}>{group.label}</h2>
      <div className="fin-list">
        {cases.map((uc) => (
          <UseCaseCard key={uc.id} useCase={uc} />
        ))}
      </div>
    </section>
  );
}

export default function LogisticsRpaDomainContent() {
  const [activeFilter, setActiveFilter] = useState("all");
  const visibleGroups =
    activeFilter === "all"
      ? LOGISTICS_GROUPS
      : LOGISTICS_GROUPS.filter((group) => group.id === activeFilter);

  return (
    <div className="fin-page">
      <DomainSeoHelmet
        intro={LOGISTICS_DOMAIN_INTRO}
        domainSlug="logistics-domain"
        basePath="/rpa-use-cases"
        useCaseCount={LOGISTICS_USE_CASES_SEO.length}
        groupCount={LOGISTICS_GROUPS.length}
        itemListJsonLd={LOGISTICS_ITEM_LIST_JSONLD}
        faqJsonLd={LOGISTICS_FAQ_JSONLD}
        breadcrumbJsonLd={LOGISTICS_BREADCRUMB_JSONLD}
        webPageJsonLd={LOGISTICS_WEBPAGE_JSONLD}
        keywords="Logistics automation, document AI + RPA, workflow automation, robotic process automation India UAE KSA UK USA"
        sectionLabel=""
      />
      <style>{DOMAIN_PAGE_STYLES}</style>
      <header className="fin-hero">
        <div className="fin-hero-inner">
          <h1>{LOGISTICS_DOMAIN_INTRO.title}</h1>
          {LOGISTICS_DOMAIN_INTRO.content ? <p>{LOGISTICS_DOMAIN_INTRO.content}</p> : null}
        </div>
      </header>
      <UseCaseIndexGrid
        useCases={LOGISTICS_USE_CASES_SEO}
        groups={LOGISTICS_GROUPS}
        heading="Logistics Use Cases"
        onFilterChange={setActiveFilter}
      />
      <div className="fin-wrap">
        {visibleGroups.map((group) => (
          <GroupSection key={group.id} group={group} />
        ))}
      </div>
      <DomainHiddenSeoContent
        domainTitle={LOGISTICS_DOMAIN_INTRO.title}
        domainFaqs={LOGISTICS_DOMAIN_FAQS}
        useCases={LOGISTICS_USE_CASES_SEO}
      />
    </div>
  );
}

